import {
  extractOnlyNumbers, parseNumericValue, parseOnlyNumericValue, removeAllSpaces, removeMultipleSpace,
  // removeSpecialCharAndNumFn, 
  removeUnderScrSpaceBet, removeUnderScrSpCharSpaceBet, safeToString, sliceText
} from "../../../utils/common";
import { safeString } from "../../../utils/logger";

import { TbListDetails, TbSettings, TbTextScan2, TbUserSquareRounded } from "react-icons/tb";

export const ORGANIZATION_INITIAL_STATE = {
  org_name: "",
  landline: "",
  phone: "",
  email: "",
  domain_name: "",
  tan_no: "",
  pan: "",
  industry_type: "option1",
  registration_type: "97",
  domain_authorization: 1,
  date_of_org: "",
  payment_type: [],
  wages_type: "",
  address: "",
  locality: "",
  city: "",
  state: 2,
  country: "India",
  pincode: "",
  landmark: "",
  previewURL: "",
}
const stateOptions = [
  { id: 'uttarakhand', name: 'Uttarakhand' },
  { id: 'west-bengal', name: 'West Bengal' },
];

export const ALLOWANCE_ACT_STATE = { actName: "", regNo: "" }

const today = new Date().toISOString().split('T')[0];
const houndredYearsAgo = new Date();
houndredYearsAgo.setFullYear(houndredYearsAgo.getFullYear() - 100);
const minDate = houndredYearsAgo.toISOString().split('T')[0];

export const ORGANIZATION_CATEGORY = [
  {
    "id": "93",
    "name": "Private Limited Company",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "94",
    "name": "Public Limited Company",
    "createdAt": "2023-04-03T12:59:16.000Z",
    "updatedAt": "2023-04-03T12:59:16.000Z"
  },
  {
    "id": "95",
    "name": "Partnerships",
    "createdAt": "2023-04-03T12:59:25.000Z",
    "updatedAt": "2023-04-03T12:59:25.000Z"
  },
  {
    "id": "96",
    "name": "LLP Registration",
    "createdAt": "2023-04-03T12:59:35.000Z",
    "updatedAt": "2023-04-03T12:59:35.000Z"
  },
  {
    "id": "97",
    "name": "One Person Company",
    "createdAt": "2023-04-03T12:59:44.000Z",
    "updatedAt": "2023-04-03T12:59:44.000Z"
  },
  {
    "id": "98",
    "name": "Sole Proprietorship",
    "createdAt": "2023-04-03T12:59:52.000Z",
    "updatedAt": "2023-04-03T12:59:52.000Z"
  },
  {
    "id": "99",
    "name": "Section 8 Company",
    "createdAt": "2023-04-03T13:00:00.000Z",
    "updatedAt": "2023-06-05T14:18:06.000Z"
  },
]
export const INDUSTRY_TYPE = [

  {
    "id": "1001",
    "name": "Retail",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1002",
    "name": "Hospitality",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1003",
    "name": "Healthcare",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1004",
    "name": "Construction",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1005",
    "name": "Manufacturing",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1006",
    "name": "Technology",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1007",
    "name": "Education",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1008",
    "name": "Professional Services",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1009",
    "name": "Transportation and Logistics",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1010",
    "name": "Nonprofit Organizations",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1011",
    "name": "Agriculture",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1012",
    "name": "Real Estate",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1013",
    "name": "Entertainment",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1014",
    "name": "Government",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1015",
    "name": "Staffing Agencies",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1016",
    "name": "Financial Services",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1017",
    "name": "Call Centers & Customer Support",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1018",
    "name": "Security Services",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1019",
    "name": "Mining and Natural Resources",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1020",
    "name": "Energy and Utilities",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1021",
    "name": "Media and Publishing",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1022",
    "name": "Textile and Apparel",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1023",
    "name": "Automotive",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1024",
    "name": "Telecommunications",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1025",
    "name": "Aerospace and Defense",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "1026",
    "name": "Biotechnology & Life Sciences",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  }
];


export const MENU_ITEMS = [
  {
    icon: <TbListDetails />,
    primaryText: "Profile Information",
    path: "organization", // Specify the correct path
    shouldDisabledNewUser: false,
  },
  {
    icon: <TbSettings />,
    primaryText: "Configurations",
    path: "organization/benefits",
    shouldDisabledNewUser: true,
  },
  
  {
    icon: <TbTextScan2 />,
    primaryText: "Allowance Data",
    path: "organization/allowance",
    shouldDisabledNewUser: true,
  },
  {
    icon: <TbUserSquareRounded />,
    primaryText: "Ownership Details",
    path: "organization/ownership", // Correct subpath
    shouldDisabledNewUser: true,
  },
];

export const ORGANIZATION_FORM_FIELDS = {

  // BASICINFORMATION: [
  org_name: {
    type: "text",
    name: "org_name",
    inputType: "inputField",
    component: "InputField",
    label: "Organization Name",
    fullWidth: true,
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeString(value), 150));
        return value;
      }
    },
    required: true,
  },
  domain_name: {
    name: "domain_name",
    inputType: "inputField",
    component: "InputField",
    label: "Domain Name",
    fullWidth: true,
    placeholder: "Type Here...",
    type: "text",
    required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(safeToString(removeAllSpaces(safeToString(value))), 150);
        return value;
      }
    }
  },
  phone: {
    name: "phone",
    inputType: "inputField",
    component: "InputField",
    label: "Phone",
    fullWidth: true,
    placeholder: "Type Here...",
    type: "tel",
    required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(parseOnlyNumericValue(removeAllSpaces(value)), 10);
        return value;
      }
    }
  },
  landline: {
    name: "landline",
    inputType: "inputField",
    component: "InputField",
    label: "Landline",
    fullWidth: true,
    placeholder: "Type Here...",
    type: "text",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeAllSpaces(extractOnlyNumbers(value)), 11);
        return value;
      }
    }
  },
  email: {
    name: "email",
    inputType: "inputField",
    component: "InputField",
    label: "Email",
    fullWidth: true,
    placeholder: "Type Here...",
    type: "text",
    required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeUnderScrSpaceBet(value.toLowerCase()), 150);
        return value;
      }
    }
  },


  // ORGANISATIONDETAILS: [
  registration_type: {
    name: "registration_type",
    inputType: "selectField",
    component: "SelectField",
    label: "Organization Category",
    fullWidth: true,
    placeholder: "Select Here...",
    options: ORGANIZATION_CATEGORY,
    required: true,
    searchable:true,
  },
  industry_type: {
    name: "industry_type",
    inputType: "selectField",
    component: "SelectField",
    label: "Industry Type",
    fullWidth: true,
    placeholder: "Select Here...",
    options: INDUSTRY_TYPE,
    searchable:true,
  },
  pan: {
    name: "pan",
    inputType: "inputField",
    component: "InputField",
    label: "Organization PAN",
    fullWidth: true,
    placeholder: "Type Here...",
    type: "text",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeUnderScrSpCharSpaceBet(value), 10);
        return value.toUpperCase();
      }

    }
  },
  tan_no: {
    name: "tan_no",
    inputType: "inputField",
    component: "InputField",
    label: "Organization TAN",
    fullWidth: true,
    placeholder: "Type Here...",
    type: "text",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeUnderScrSpCharSpaceBet(value), 10);
        return value.toUpperCase();
      }
    }
  },
  date_of_org: {
    name: "date_of_org",
    inputType: "dateField",
    component: "InputField",
    label: "Date of Establishment",
    fullWidth: true,
    placeholder: "Type Here...",
    type: "date",
    max: today,
    min: minDate
  },
  payment_type: {
    required: true,
    name: "payment_type",
    inputType: "selectField",
    component: "SelectField",
    label: "Payment Type",
    fullWidth: true,
    multiSelect: true,
    placeholder: "Select Here...",
    options: [
      { id: "salary", name: "Salary" },
      { id: "wages", name: "Wages" },
    ],
  },
  wages_type: {
    required: true,

    name: "wages_type",
    inputType: "selectField",
    component: "SelectField",
    label: "Wages Type",
    fullWidth: true,
    placeholder: "Select Here...",
    options: [
      { id: "monthly", name: "Monthly" },
      { id: "fixed_date", name: "Fixed Date" },
    ],
  },
  wages_days: {
    required: true,
    name: "wages_days",
    component: "SelectField",
    label: "Wages Days",
    fullWidth: true,
    placeholder: "Select Here...",
    inputType: "inputField",
    type: "text",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(parseNumericValue(value), 2);
        return value;
      }
    },

  },

  // ORGANISATIONADDRESS: [
  address: {
    name: "address",
    inputType: "inputField",
    component: "InputField",
    label: "Address",
    fullWidth: true,
    placeholder: "Type Here",
    type: "text",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeToString(value)), 150);
        return value;
      }
    }
  },
  city: {
    name: "city",
    inputType: "inputField",
    component: "InputField",
    label: "City/District",
    fullWidth: true,
    placeholder: "Type Here",
    type: "text",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeToString(value)), 100);
        return value;
      }
    }
  },
  state: {
    name: "state",
    inputType: "selectField",
    component: "SelectField",
    label: "State",
    fullWidth: true,
    placeholder: "Select Here...",
    options: stateOptions,
  },
  country: {
    name: "country",
    inputType: "selectField",
    component: "SelectField",
    label: "Country",
    fullWidth: true,
    placeholder: "Select Here...",
    options: [
      { id: "India", name: "India" },
      { id: "no", name: "No" },
    ],
    disabled: true,
  },
  pincode: {
    name: "pincode",
    inputType: "inputField",
    component: "InputField",
    label: "Pincode",
    fullWidth: true,
    placeholder: "Type Here",
    type: "text",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(parseOnlyNumericValue(safeToString(value)), 6);
        return value;
      }
    }
  },
  locality: {
    name: "locality",
    inputType: "inputField",
    component: "InputField",
    label: "Location",
    fullWidth: true,
    placeholder: "Type Here",
    type: "text",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeToString(value)), 150);
        return value;
      }
    }
  },
  landmark: {
    name: "landmark",
    inputType: "inputField",
    component: "InputField",
    label: "Landmark",
    fullWidth: true,
    placeholder: "Type Here",
    type: "text",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeToString(value)), 100);
        return value;
      }
    }
  },
};



